// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NEQxKqqdQ4utD2JoAecL {
  width: 100%;
  height: 100%;
  background-color: white;
  padding: 16px;
  border-radius: 8px;
  justify-content: space-between;
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  border-bottom: 1px solid #c4c4c4;
}

.bGC6aSjGCukJeXhuS9fc {
  display: flex;
  flex-direction: column;
  row-gap: 16px;
}

.cz0jyXEifdDX1moIPtnb {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  max-height: calc(100vh - 18rem);
}

.bPEs0ycYxJxOM3AANuKz, .eJiipe3YttV48AuxhyOc {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  column-gap: 32px;
}

.eJiipe3YttV48AuxhyOc {
  margin-bottom: 16px;
}

.wmr_zPB1qFdylhlhPt8b {
  display: flex;
  flex-direction: row;
  column-gap: 4px;
  padding-bottom: 4px;
  font-family: "Chakra Petch";
  font-size: 18px;
  font-weight: bold;
  border-bottom: 1px solid #c4c4c4;
}

.rqfz9rvozDUOCpYn7tFF {
  color: #48CAE4;
}

.yqH2dNyZPvgO6PVQuuPC {
  display: grid;
  grid-auto-columns: calc(25% - 32px) calc(25% - 32px) calc(25% - 32px) calc(25% - 32px);
  column-gap: 32px;
}

.Xh3owh5Pua19X1AlnvuW {
  display: flex;
  flex-direction: row;
  flex: 2 1;
  column-gap: 32px;
}

.wAacC0jYBUjuAC2e_OAo {
  min-width: 160px;
}

.REc5ki4u19e9bld_eRJN {
  width: 100%;
}

.xSHdVOePkHZrnehNfq7K {
  min-width: 300px;
}

.F4bjQdzgMyOCCrjjgWh2 {
  min-height: 200px;
  width: 100%;
}

.v1t2MTowR_ESYCCt4Sfs {
  display: flex;
  flex-direction: row;
  justify-content: end;
  font-family: "Chakra Petch";
  font-size: 14px;
  font-weight: bold;
  color: #D62828;
  padding-bottom: 16px;
}

.YKmzLXrVuC_JZGD2vMnT {
  display: flex;
  flex-direction: row;
  column-gap: 16px;
  justify-content: end;
}

.BFqvrh0zCjEeT2GjlHVX {
  background-color: #D62828;
  color: white;
}
.BFqvrh0zCjEeT2GjlHVX:hover {
  color: white;
  border-color: #FCBF49;
}

.vxUZxy8h9QtqIuz9gvkf {
  background-color: darkorange;
  color: white;
}

.lxKhGiyQiPX_PMYKGlCr {
  flex-grow: 1;
}

.a9xBxzSTKXPA2nmwDcRO {
  overflow-y: auto;
  display: flex;
  overflow-x: clip;
  flex-direction: column;
}

.PCfTaIRNv5A8yxbZi0gg {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.wbr1DaUGoMic1vENpIMK {
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.lF1_LteOq4Jd_w4Bv2Vg {
  font-family: "Chakra Petch";
  font-size: 20px;
  font-weight: 500;
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  flex-direction: column;
}

.wwK3fhzzacDz_uv_kY2S {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 32px;
}

.zD8hxpO0yOTp_snSQOsg {
  min-width: 150px;
}

.vEWY0scYY3_dvAVASwqQ {
  display: flex;
  flex-direction: column;
  row-gap: 8px;
}

.ITTPbNZy8nXyQWgt3mGD {
  font-family: "Chakra Petch";
  font-size: 16px;
  font-weight: 500;
}

.TSspdQcnimAD3rXls82r {
  display: flex;
  flex-direction: column;
  row-gap: 16px;
}

.qAVwBC3UKD6lxX9yq9QP {
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ivBrAz4dhXbjx83EoAQq {
  width: 90vw;
  max-width: 1900px;
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  padding: 16px;
  background-color: white;
  border-radius: 8px;
}

.kFx4ThchjacQP6OZmjLn {
  display: flex;
  flex-direction: column;
  row-gap: 8px;
}

.lemDjdgaCxOGUVSRsHEh {
  display: grid;
  flex-direction: row;
  grid-template-columns: 2fr 2fr 3fr 140px 90px 90px 50px;
  column-gap: 16px;
}

.X8yjUIiMn6WG3PTKFAHS {
  display: flex;
  flex-direction: row;
  column-gap: 16px;
}

.c0roUrsXEnYmotTX0_T2 {
  max-width: 160px;
}

.DH8WZhJgiT7t_XoI8j7h {
  max-width: 400px;
}

.raubzyca4k94qXPfhk1E {
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  width: 40px;
  color: black;
  height: 40px;
}
.raubzyca4k94qXPfhk1E:hover {
  color: #D62828;
}

.mWIMZVFJgSlKJfJLt_gw {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 16px;
}

.ACaiFwQhdAR8ND5XNEjV {
  width: 400px;
  background: rgba(0, 0, 0, 0.6) !important;
}`, "",{"version":3,"sources":["webpack://./src/screens/MissionEdit/MissionCreateOrEdit.module.scss"],"names":[],"mappings":"AACA;EACI,WAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,8BAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,gCAAA;AAAJ;;AAGA;EACI,aAAA;EACA,sBAAA;EACA,aAAA;AAAJ;;AAGA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,+BAAA;AAAJ;;AAGA;EACI,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,gBAAA;AAAJ;;AAGA;EAEI,mBAAA;AADJ;;AAIA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;EACA,iBAAA;EACA,gCAAA;AADJ;;AAIA;EAEI,cAAA;AAFJ;;AAMA;EACI,aAAA;EACA,sFAAA;EACA,gBAAA;AAHJ;;AAMA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AAHJ;;AAOA;EACI,gBAAA;AAJJ;;AAOA;EACI,WAAA;AAJJ;;AAOA;EACI,gBAAA;AAJJ;;AAOA;EACI,iBAAA;EACA,WAAA;AAJJ;;AAOA;EACI,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,2BAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,oBAAA;AAJJ;;AAOA;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;AAJJ;;AAOA;EACI,yBAAA;EACA,YAAA;AAJJ;AAKI;EACI,YAAA;EACA,qBAAA;AAHR;;AAOA;EACI,4BAAA;EACA,YAAA;AAJJ;;AAOA;EACI,YAAA;AAJJ;;AAOA;EACI,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;AAJJ;;AAOA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAJJ;;AAOA;EACI,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAJJ;;AAOA;EACI,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AAJJ;;AAOA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AAJJ;;AAOA;EACI,gBAAA;AAJJ;;AAOA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AAJJ;;AAOA;EACI,2BAAA;EACA,eAAA;EACA,gBAAA;AAJJ;;AAOA;EACI,aAAA;EACA,sBAAA;EACA,aAAA;AAJJ;;AAOA;EACI,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAJJ;;AAOA;EACI,WAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;AAJJ;;AAOA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AAJJ;;AAOA;EACI,aAAA;EACA,mBAAA;EACA,uDAAA;EACA,gBAAA;AAJJ;;AAOA;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;AAJJ;;AAOA;EACI,gBAAA;AAJJ;;AAOA;EACI,gBAAA;AAJJ;;AAOA;EACI,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAJJ;AAKI;EACI,cAAA;AAHR;;AAOA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,oBAAA;AAJJ;;AAOA;EACI,YAAA;EACA,yCAAA;AAJJ","sourcesContent":["\r\n.missionAdminContainer {\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: white;\r\n    padding: 16px;\r\n    border-radius: 8px;\r\n    justify-content: space-between;\r\n    display: flex;\r\n    flex-direction: column;\r\n    row-gap: 16px;\r\n    border-bottom: 1px solid #c4c4c4;\r\n}\r\n\r\n.missionContent {\r\n    display: flex;\r\n    flex-direction: column;\r\n    row-gap: 16px;\r\n}\r\n\r\n.editIDOContainer {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow-y: auto;\r\n    max-height: calc(100vh - 18rem);\r\n}\r\n\r\n.editRow {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-evenly;\r\n    column-gap: 32px;\r\n}\r\n\r\n.valueRow {\r\n    @extend .editRow;\r\n    margin-bottom: 16px;\r\n}\r\n\r\n.ongoingRaffleValueContainer {\r\n    display: flex;\r\n    flex-direction: row;\r\n    column-gap: 4px;\r\n    padding-bottom: 4px;\r\n    font-family: \"Chakra Petch\";\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    border-bottom: 1px solid #c4c4c4;\r\n}\r\n\r\n.ongoingRaffleValue {\r\n\r\n    color: #48CAE4;\r\n\r\n}\r\n\r\n.stakerOptions {\r\n    display: grid;\r\n    grid-auto-columns: calc(25% - 32px) calc(25% - 32px) calc(25% - 32px) calc(25% - 32px);\r\n    column-gap: 32px;\r\n}\r\n\r\n.textAreaInputRow {\r\n    display: flex;\r\n    flex-direction: row;\r\n    flex: 2 1;\r\n    column-gap: 32px;\r\n}\r\n\r\n\r\n.checkboxContainer {\r\n    min-width: 160px;\r\n}\r\n\r\n.subTaskItem {\r\n    width: 100%;\r\n}\r\n\r\n.imageInputContainer {\r\n    min-width: 300px;\r\n}\r\n\r\n.editorContainer {\r\n    min-height: 200px;\r\n    width: 100%;\r\n}\r\n\r\n.missingRaffleValuesContainer {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: end;\r\n    font-family: \"Chakra Petch\";\r\n    font-size: 14px;\r\n    font-weight: bold;\r\n    color: #D62828;\r\n    padding-bottom: 16px;\r\n}\r\n\r\n.bottomActionContainer {\r\n    display: flex;\r\n    flex-direction: row;\r\n    column-gap: 16px;\r\n    justify-content: end;\r\n}\r\n\r\n.deleteButton {\r\n    background-color: #D62828;\r\n    color: white;\r\n    &:hover {\r\n        color: white;\r\n        border-color: #FCBF49;\r\n    }\r\n}\r\n\r\n.forceButton {\r\n    background-color: darkorange;\r\n    color: white;\r\n}\r\n\r\n.flexGrower {\r\n    flex-grow: 1;\r\n}\r\n\r\n.idoInputContainer {\r\n    overflow-y: auto;\r\n    display: flex;\r\n    overflow-x: clip;\r\n    flex-direction: column;\r\n}\r\n\r\n.buttonContainer {\r\n    width: 100%;\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n}\r\n\r\n.deleteIdoModalOverlay {\r\n    background-color: rgba(0, 0, 0, 0.6);\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 100%;\r\n    top: 0;\r\n    left: 0;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.deleteIdoModal {\r\n    font-family: \"Chakra Petch\";\r\n    font-size: 20px;\r\n    font-weight: 500;\r\n    background-color: white;\r\n    border-radius: 8px;\r\n    padding: 20px;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.deleteRow {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    margin-top: 32px    ;\r\n}\r\n\r\n.selectInputContainer {\r\n    min-width: 150px;\r\n}\r\n\r\n.tokenModalContainer {\r\n    display: flex;\r\n    flex-direction: column;\r\n    row-gap: 8px;\r\n}\r\n\r\n.raffleTokenText {\r\n    font-family: \"Chakra Petch\";\r\n    font-size: 16px;\r\n    font-weight: 500;\r\n}\r\n\r\n.taskListContainer {\r\n    display: flex;\r\n    flex-direction: column;\r\n    row-gap: 16px;\r\n}\r\n\r\n.editTaskModalContainer {\r\n    background-color: rgba(0, 0, 0, 0.6);\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 100%;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 1000;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.taskModalContent {\r\n    width: 90vw;\r\n    max-width: 1900px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    row-gap: 16px;\r\n    padding: 16px;\r\n    background-color: white;\r\n    border-radius: 8px;\r\n}\r\n\r\n.taskActionContainer {\r\n    display: flex;\r\n    flex-direction: column;\r\n    row-gap: 8px;\r\n}\r\n\r\n.subTaskRow {\r\n    display: grid;\r\n    flex-direction: row;\r\n    grid-template-columns: 2fr 2fr 3fr 140px 90px 90px 50px;\r\n    column-gap: 16px;\r\n}\r\n\r\n.datetimePickerContainer {\r\n    display: flex;\r\n    flex-direction: row;\r\n    column-gap: 16px;\r\n}\r\n\r\n.smallTextInputContainer {\r\n    max-width: 160px;\r\n}\r\n\r\n.mediumTextInputContainer {\r\n    max-width: 400px;\r\n}\r\n\r\n.trashIconContainer {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: end;\r\n    align-items: center;\r\n    cursor: pointer;\r\n    transition: all 0.2s ease-in-out;\r\n    width: 40px;\r\n    color: black;\r\n    height: 40px;\r\n    &:hover {\r\n        color: #D62828;\r\n    }\r\n}\r\n\r\n.missionHeader {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding-bottom: 16px;\r\n}\r\n\r\n.tabSelector {\r\n    width: 400px;\r\n    background: rgba(0, 0, 0, 0.6) !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"missionAdminContainer": `NEQxKqqdQ4utD2JoAecL`,
	"missionContent": `bGC6aSjGCukJeXhuS9fc`,
	"editIDOContainer": `cz0jyXEifdDX1moIPtnb`,
	"editRow": `bPEs0ycYxJxOM3AANuKz`,
	"valueRow": `eJiipe3YttV48AuxhyOc`,
	"ongoingRaffleValueContainer": `wmr_zPB1qFdylhlhPt8b`,
	"ongoingRaffleValue": `rqfz9rvozDUOCpYn7tFF`,
	"stakerOptions": `yqH2dNyZPvgO6PVQuuPC`,
	"textAreaInputRow": `Xh3owh5Pua19X1AlnvuW`,
	"checkboxContainer": `wAacC0jYBUjuAC2e_OAo`,
	"subTaskItem": `REc5ki4u19e9bld_eRJN`,
	"imageInputContainer": `xSHdVOePkHZrnehNfq7K`,
	"editorContainer": `F4bjQdzgMyOCCrjjgWh2`,
	"missingRaffleValuesContainer": `v1t2MTowR_ESYCCt4Sfs`,
	"bottomActionContainer": `YKmzLXrVuC_JZGD2vMnT`,
	"deleteButton": `BFqvrh0zCjEeT2GjlHVX`,
	"forceButton": `vxUZxy8h9QtqIuz9gvkf`,
	"flexGrower": `lxKhGiyQiPX_PMYKGlCr`,
	"idoInputContainer": `a9xBxzSTKXPA2nmwDcRO`,
	"buttonContainer": `PCfTaIRNv5A8yxbZi0gg`,
	"deleteIdoModalOverlay": `wbr1DaUGoMic1vENpIMK`,
	"deleteIdoModal": `lF1_LteOq4Jd_w4Bv2Vg`,
	"deleteRow": `wwK3fhzzacDz_uv_kY2S`,
	"selectInputContainer": `zD8hxpO0yOTp_snSQOsg`,
	"tokenModalContainer": `vEWY0scYY3_dvAVASwqQ`,
	"raffleTokenText": `ITTPbNZy8nXyQWgt3mGD`,
	"taskListContainer": `TSspdQcnimAD3rXls82r`,
	"editTaskModalContainer": `qAVwBC3UKD6lxX9yq9QP`,
	"taskModalContent": `ivBrAz4dhXbjx83EoAQq`,
	"taskActionContainer": `kFx4ThchjacQP6OZmjLn`,
	"subTaskRow": `lemDjdgaCxOGUVSRsHEh`,
	"datetimePickerContainer": `X8yjUIiMn6WG3PTKFAHS`,
	"smallTextInputContainer": `c0roUrsXEnYmotTX0_T2`,
	"mediumTextInputContainer": `DH8WZhJgiT7t_XoI8j7h`,
	"trashIconContainer": `raubzyca4k94qXPfhk1E`,
	"missionHeader": `mWIMZVFJgSlKJfJLt_gw`,
	"tabSelector": `ACaiFwQhdAR8ND5XNEjV`
};
export default ___CSS_LOADER_EXPORT___;
